module.exports = __webpack_public_path__ + "img/modelug_14.0f0565d5.jpg";